import React from 'react'

// 标题内容公共样式组件
// title：标题
const TitleComp = ({ children, title }) => {
  return (
    <div className="w-full">
      <div className="h-8 flex items-center text-black font-medium">
        {title}
      </div>
      {children}
    </div>
  )
}

export default TitleComp
